/* eslint-disable no-useless-constructor */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react'

import TaContext from './TaContext';
import ContactFormComponent from "../../components/ContactForm";
import { CONTACT_TIME, CONTACT_REASON } from "../../data/personal";

import CloseTab from "../../images/close.svg";

const imgScale = { width: "24px", height: "24px"};
const Icon = props =>  <img className={props.className} src={props.src} {...imgScale} />

class Step7 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }
  
  render() {
    const { step7 } = this.context;
    const { onNavigate } = step7;
    const {
      cName,
      cLastName,
      cMobile,
      cEmail,
      cReason,
      cDetail,
      cDate,
      cTime,
      onChangeModel
    } = step7;
    return (
      <div className="form-wrapper">
        <div className="form-group">
          <div className="header" onClick={() => onNavigate(1)}>
            <Icon className="float-right" src={CloseTab} />
          </div>
          <label className="text-blue font-bold mb-3 mt-3 ml-0">
            สนใจให้เจ้าหน้าที่ติดต่อกลับ
          </label>
          <div className="form-group">
            <ContactFormComponent
              productName={'MTI06149'}
              time={CONTACT_TIME}
              reason={CONTACT_REASON}
              cName={cName}
              cLastName={cLastName}
              cMobile={cMobile}
              cEmail={cEmail}
              cReason={cReason}
              cDetail={cDetail}
              cDate={cDate}
              cTime={cTime}
              onChange={onChangeModel}
              productNAme={""}
              onSubmit={() => (window.location.href = "/?callback=1")}
            />
          </div>
        </div>
      </div>
    )
  }
}

Step7.contextType = TaContext;
export default Step7;